<template>
	<div class="view news-detail-view" id="newsDetailView">
		<HeaderBar :backFunction="onBack">
			<img v-if="!is_collect"
				 class="fav-img"
				 src="../../assets/images/unfav.png"
				 alt="收藏"
				 @click="onFavClick" />
			<img v-else
				 class="fav-img"
				 src="../../assets/images/fav2.png"
				 alt="取消收藏"
				 @click="onUnfavClick" />

			<img class="share-img"
				 src="../../assets/images/share.png"
				 alt="分享"
				 @click="shareVisible = true" />
		</HeaderBar>
		<div id="viewWrap">
			<div class="companyinfo">
				<img :src="detialData.img_path" alt="">
				<div v-html="detialData.name"></div>
				<!-- <div class="comname">{{detialData.name}}</div> -->
			</div>
			<van-tabs class="tabs" v-model="tabActive" :line-height="3" :line-width="80" title-inactive-color="#000" title-active-color="#000">
				<van-tab class="tabitem" v-for="(tabitem, index) in detialData.tab" :title="tabitem.title" :key="index">
					<div class="tabcontent">
						<div v-html="tabitem.value"></div>
					</div>
				</van-tab>
			</van-tabs>
			<template v-if="tabActive==0" >
				<div class="companyurl" v-for="(urlItem, urlIndex) in detialData.url" :key="urlIndex" @click="openUrl(urlItem.value)">
					<div class="urllayout">
						<span class="urlnames">企业网址 : </span>
						<div v-html="urlItem.value"></div>
						<!-- <span class="urlvalues">{{urlItem.value}}</span> -->
					</div>
					<img src="@/assets/images/data/url.jpg" alt="">
				</div>
				<div v-show="(typeId == '101' || typeId == '102') && detialData.echartdata.linedata">
					<div class="chartline">
						<span class="greenbottom">历年认证绿色建筑项目数量</span>
					</div>
					<CardItem :topinfo="detialData.echartdata.linedata">
						<template #echartitem>
							<LineEcharts :echartdata="detialData.echartdata" />
						</template>
					</CardItem>
				</div>
				<div v-show="(typeId == '103' || typeId == '104') && detialData.echartdata.columdata">
					<div class="chartline">
						<span class="greenbottom">历年项目市场走势</span>
					</div>
					<CardItem :topinfo="detialData.echartdata.columdata">
						<template #echartitem>
							<ColumentOneChart :echartdata="detialData.echartdata" />
						</template>
					</CardItem>
				</div>
				<!-- 绿色建筑市场明细 -->
				<div class="devides" v-show="typeId == '103' || typeId == '104'"></div>
				<div id="viewWrap" v-show="typeId == '103' || typeId == '104'">
					<div class="yearnumber" v-for="item in detialData.sub" :key="item.id">
						<div class="yeartitle">
							<div class="numbers">
								{{item.year}}
							</div> 
							<div class="lines">
							</div>
						</div>
						<div class="yearcontent">
							<template v-if="item.value[0].length>0">
								<div class="contentlay" v-for="(buildItem, bIndex) in item.value[0]" :key="bIndex">
									{{buildItem.title}}{{buildItem.unit}}
									<span class="contentfont">{{buildItem.value}}</span>
								</div>
							</template>
							<template v-if="item.area">
								<div :class="'year'+item.year" v-show="showDetial" class="eltables">
									<el-table
										:data="item.area"
										stripe
										style="width: 100%">
										<el-table-column
											prop="title"
											label="地区"
											>
										</el-table-column>
										<el-table-column
											prop="number"
											label="项目数(个)"
											>
										</el-table-column>
										<el-table-column
											prop="area"
											label="项目面积(万㎡)"
											width="100">
										</el-table-column>
										<el-table-column
											prop="coverage"
											label="覆盖率">
										</el-table-column>
									</el-table>
								</div>
							</template>
							<!-- <div class="contentlay">认证项目数量（个）: <span class="contentfont">{{item.number}}</span></div>
							<div class="contentlay">认证项目面积（㎡）: <span class="contentfont">{{item.money}}</span> </div>
							<div class="contentlay">销售面积（万平米）：<span class="contentfont">{{item.meter}}</span> </div>
							<div class="contentlay">中国项目数量（个） :<span class="contentfont">{{item.profit}}</span> </div>
							<div class="contentlay">全球项目数量（个）:<span class="contentfont">{{item.devmon}}</span> </div> -->
						</div>
						<div class="seedetial" @click="getDetial(item.year)">
							<span class="contentfont" :class="'contentfont'+item.id">{{detailName}}</span>
							<img class="seeimg" :class="'seeimg'+item.year" :src="detialImg" alt="">
						</div>
					</div>
				</div>
				<div id="viewWrap" v-show="(typeId == '101' || typeId == '102')">
					<div class="yearnumber" v-for="item in detialData.sub" :key="item.id">
						<div class="yeartitle">
							<div class="numbers">
								{{item.year}}
							</div> 
							<div class="lines">
							</div>
						</div>
						<div class="yearcontent">
							<div class="contentlay" v-for="(conItem, index) in item.value[0]">
								{{conItem.title}}{{conItem.unit}}
								<span class="contentfont">{{conItem.value}}</span>
							</div>
							<div :class="'year'+item.year" v-show="showDetial">
								<div class="contentlay" v-for="(conItem, index) in item.value[1]" :class="'year'+item.year">
									{{conItem.title}}{{conItem.unit}}
									<span class="contentfont">{{conItem.value}}</span>
								</div>
								<div class="contentlay" v-for="(conItem, index) in item.value[2]" :class="'year'+item.year">
									{{conItem.title}}{{conItem.unit}}
									<span class="contentfont">{{conItem.value}}</span>
								</div>
							</div>
							<div v-if="typeId == '101'" class="seedetial" @click="getDetial(item.year)">
								<span class="contentfont" :class="'contentfont'+item.year">{{detailName}}</span>
								<img class="seeimg" :class="'seeimg'+item.year" :src="detialImg" alt="">
							</div>
							<!-- <div class="contentlay">PRIMB 得分: <span class="contentfont">{{item.number}}</span></div>
							<div class="contentlay">产值（亿元）: <span class="contentfont">{{item.money}}</span> </div>
							<div class="contentlay">销售面积（万平米）：<span class="contentfont">{{item.meter}}</span> </div>
							<div class="contentlay">利润率 :<span class="contentfont">{{item.profit}}</span> </div>
							<div class="contentlay">研发投入（万元）:<span class="contentfont">{{item.devmon}}</span> </div>
							<div :class="'year'+item.id" v-show="showDetial">
								<div class="contentlay">研发产出（专利和著作权数量）:<span class="contentfont">{{item.devpro}}</span> </div>
								<div class="contentlay">规模系数:<span class="contentfont">{{item.ratio}}</span> </div>
								<div class="layoutdev"></div>
								<div class="contentlay">国标设计标识认证面积（万平米）:<span class="contentfont">{{item.gmeter}}</span> </div>
								<div class="contentlay">国标设计标识认证项目数量（个）:<span class="contentfont">{{item.gmesum}}</span> </div>
								<div class="contentlay">三星级项目数量:<span class="contentfont">{{item.threestar}}</span> </div>
								<div class="layoutdev"></div>
								<div class="contentlay">国际绿色标准认证面积（万平米）:<span class="contentfont">{{item.intergreen}}</span> </div>
								<div class="contentlay">国际绿色标准认证项目数量（个）:<span class="contentfont">{{item.intergreensum}}</span> </div>
								<div class="contentlay">铂金级项目数量:<span class="contentfont">{{item.plat}}</span> </div>
							</div> -->
						</div>
					</div>
				</div>
				<!-- 绿色运营明细 -->
				<div class="yeartable" v-show="false">
					<!-- 表格 -->
					<el-table
						:data="yearData"
						stripe
						style="width: 100%">
						<el-table-column
							prop="year"
							label="评估年份"
						>
						</el-table-column>
						<el-table-column
							prop="number"
							label="得分"
						>
						</el-table-column>
						<el-table-column
							prop="gmeter"
							label="国内认证面积"
							width="100"
							>
						</el-table-column>
						<el-table-column
							prop="intergreen"
							label="国际认证面积"
							width="100">
						</el-table-column>
						<el-table-column
							prop="gmesum"
							label="PRIMB得分">
						</el-table-column>
					</el-table>
					<!-- <table >
						<tr class="tablehead">
							<th  v-for="yearitem in tableHeader" :key="yearitem.id">{{yearitem.name}}</th>
						</tr>
						<tr v-for="item in yearData" :key="item.id" class="tabldata">
							<td>{{item.year}}</td>
							<td>{{item.number}}</td>
							<td>{{item.gmeter}}</td>
							<td>{{item.intergreen}}</td>
							<td>{{item.gmesum}}</td>
						</tr>
					</table> -->
				</div>
			</template>
		</div>
		<PopLoading v-show="isLoading" />
		<SharePanel v-show="shareVisible"
      @cancel="shareVisible = false;" :content="short_desc" :cover="cover" :title="title" :contentType="1" :dataType="1" />
	</div>
</template>

<script>
import envnetBus from '@/utils/eBus'
import { Toast } from 'mint-ui'
import { Tab, Tabs } from 'vant';
import apiConst from '@/consts/apiConst';
import apiUtil from '@/utils/apiUtil';
import HeaderBar from '../../components/HeaderBar';
// import TagItem from '../../components/TagItem.vue';
// import NewsItem from '../../components/NewsItem.vue';
import PopLoading from '../../components/PopLoading.vue';
import SharePanel from '../../components/SharePanel'
import TabItem from '@/components/TabItem'
import LineEcharts from '@/components/LineEcharts'
import CardItem from '@/components/CardItem'
import ColumentOneChart from '@/components/ColumentOneChart'
import { Table, TableColumn }  from 'element-ui';
export default {
	name: 'newsDetail',
	components: {
		HeaderBar,
		// TagItem,
		// NewsItem,
		PopLoading,
		SharePanel,
		shareVisible: false,
		TabItem,
		'van-tabs':Tabs,
		'van-tab':Tab,
		LineEcharts,
		CardItem,
		ColumentOneChart,
		'el-table': Table,
		'el-table-column': TableColumn
	},
	data() {
		return {
			id: 0,
			avatar: '',
			cate_name: '',
			content: '',
			cover: '',
			nickname: '',
			publish_date: '',
			tagList: [],
			title: '',
			view: 0,
			is_collect: 0,
			action_id: 0,
			is_admin_publish: 0,
			source: '',
			short_desc: '',
			relNewsList: [],
			isLoading: false,
			shareVisible: false,
			firstLoaded: false,
			// 数据明细字段
			companyName: '北京柠檬树绿色建筑科技有限公司',
			companyLogo: require('@/assets/images/data/list02.jpg'),
			tabActive:0,
			tabArr: [
				// { id: '1',  name: '企业简介', content: '企业简介,友绿网是一个构建在知识社区和产业大数据上的研究型绿色科技数字媒体平台，致力于打造房地产全产业链科技创新交流平台和科技情报服务平台。'},
				// { id: '2', name: '绿色战略', content: '绿色战略,友绿网是一个构建在知识社区和产业大数据上的研究型绿色科技数字媒体平台'},
				// { id: '3', name: '产品体系', content: '产品体系,友绿网是一个构建在知识社区和产业大数据上的研究型绿色科技数字媒体平台'},
				// { id: '4', name: '技术创新', content: '技术创新,友绿网是一个构建在知识社区和产业大数据上的研究型绿色科技数字媒体平台，致力于打造房地产全产业链科技创新交流平台和科技情报服务平台。'},
				// { id: '5', name: '绿色成就', content: '绿色成就,友绿网是一个构建在知识社区和产业大数据上的研究型绿色科技数字媒体平台，致力于打造房地产全产业链科技创新交流平台和科技情报服务平台。'}
			],
			companyurl: '官方网站: www.igreen.org',
			greenOps: [
				{ id: '1',  name: '历年绿色运营指数'}
			],
			chartData: {
				echartdata:{
					linedata:{
						xData:[2020, 2019, 2014],
						yData:[20, 19, 10]
					},
					columdata:{
						xData: ['2010', '2011', '2012', '2013', '2014', '2015', '2016'],
						seriesData: ['100','110','130','150','170','115','180']
					}
				}
			},
			// 明细里年度数据
			yearData: [
				{ id: '0', year: '2019年', number: '72', money: '2.76', meter: '7.89', profit: '13.67%', devmon: '23400', devpro: '32', ratio: '0.76', gmeter: '87', gmesum: '18', threestar: '15', intergreen: '45', intergreensum: '13', plat: '5' },
				{ id: '1', year: '2018年', number: '70', money: '2.5', meter: '6.9', profit: '11%', devmon: '23400', devpro: '32', ratio: '0.76', gmeter: '87', gmesum: '18', threestar: '15', intergreen: '45', intergreensum: '13', plat: '5' },
				{ id: '2', year: '2017年', number: '50', money: '2.0', meter: '5.9', profit: '7%', devmon: '23400', devpro: '32', ratio: '0.76', gmeter: '87', gmesum: '18', threestar: '15', intergreen: '45', intergreensum: '13', plat: '5' },
			],
			showDetial: false,
			detailName: '详细展开',
			detialImg: require('@/assets/images/data/down2.jpg'),
			tableHeader: [
				{ name: '评估年份', id: '0', },
				{ name: '得分', id: '1' },
				{ name: '国内认证面积', id: '2' },
				{ name: '国际认证面积', id: '3' },
				{ name: 'PRIMB得分', id: '4' }
			],
			typeId: '',
			budilDetial: [
				{ id: '0', year: '2019年', number: '72', money: '2.76', meter: '7.89', profit: '13.67%', devmon: '23400'},
				{ id: '1', year: '2018年', number: '71', money: '2.6', meter: '7.89', profit: '13.67%', devmon: '23400'},
				{ id: '2', year: '2017年', number: '70', money: '2.5', meter: '7.89', profit: '13.67%', devmon: '23400'}
			],
			tableData: [{
				area: '上海',
				prosum: '87',
				prometer: '123.4',
				profu: '13%'
			}, {
				area: '北京',
				prosum: '85',
				prometer: '123.4',
				profu: '13%'
			}, {
				area: '天津',
				prosum: '84',
				prometer: '123.4',
				profu: '13%'
			}, {
				area: '重庆',
				prosum: '83',
				prometer: '123.4',
				profu: '13%'
			}],
			detialData: {
				url: [{
					title: '',
					value: ''
				}],
				sub: [],
				tab: [],
			}
		}
	},
	created() {
		this.id = this.$route.query.typeid;
		this.typeId = this.$route.query.typeid;
		this.jumpId = this.$route.query.id
		this.getDetialData(this.jumpId, this.id)
	},
	watch: {
		'$route'(to, from) {
			console.log(from)
			const newId = to.query.id
			if (this.id !== newId) {
				// this.init(newId)
				// this.id = newId
				// this.getDetialData(this.jumpId, this.id)
				this.typeId = this.$route.query.typeid;
				this.id = this.$route.query.typeid;
				this.jumpId = this.$route.query.id
				this.getDetialData(this.jumpId, this.id)
				this.scrollToTop();
			}
		}
	},
	methods: {
		onBack() {
			if(sessionStorage.getItem('hasList')){
				sessionStorage.setItem('dataid', this.$route.query.typeid)
			}
			this.$router.push({
				path: '/data',
				query: {
					dataId: this.$route.query.typeid
				}
			})
		},
		async getDetialData(jumpId,id){
			let res = await apiUtil.get(apiConst.dataDetial, { jump_id: jumpId, id: id});
			console.log(res)
			if (res.data) {
				this.detialData = res.data
				document.title = this.detialData.name
				this.title = this.detialData.tab[0].value
				this.content = this.detialData.tab[1].value
				console.log(this.title)
				console.log(this.content)
			}
		},
		getDetial(index){
			if($(".year"+index).css("display") == 'block'){
				console.log(".seeimg"+index)
				$(".contentfont"+index).text('详细展开');
				$(".seeimg"+index).attr('src',require('@/assets/images/data/down2.jpg'));
				$(".year"+index).css({display:'none'});
				// this.detailName = '详细展开';
				// this.detialImg = require('@/assets/images/data/down2.jpg');
			}else{
				console.log(".seeimg"+index)
				$(".contentfont"+index).text('收起');
				$(".seeimg"+index).attr('src',require('@/assets/images/data/up2.jpg'));
				$(".year"+index).css({display:'block'});
				// this.detailName = '收起';
				// this.detialImg = require('@/assets/images/data/up2.jpg');
			}
			// this.showDetial = !this.showDetial;
		},
		openUrl(url){
			window.location.href = url
		},
		scrollToTop(){
			this.$nextTick(() => {
				setTimeout(() => {
					let scrollTop = this.$el.querySelector('#viewWrap');
					scrollTop.scrollTop = 0;
				}, 13)
			})
		},
		async init(id) {
			this.isLoading = true;
      // const res = await apiUtil.post(apiConst.getNewsDetail, { news_id: id });
      
			this.isLoading = false;
			this.firstLoaded = true;
			// if (res) {
			// 	const {
			// 		avatar,
			// 		cate_name,
			// 		content,
			// 		cover,
			// 		nickname,
			// 		publish_date,
			// 		tag,
			// 		title,
			// 		view,
			// 		action_id,
			// 		is_admin_publish,
			// 		source,
			// 		short_desc
			// 	} = res.list;
			// 	this.avatar = avatar;
			// 	this.cate_name = cate_name;
			// 	this.content = content;
			// 	this.cover = cover;
			// 	this.nickname = nickname;
			// 	this.publish_date = publish_date;
			// 	this.tagList = tag.map((ele, index) => {
			// 		if (index <= 3) {
			// 			ele.name = ele.title;
			// 			return ele;
			// 		}
			// 	});
			// 	this.title = title;
			// 	this.view = view;
			// 	this.is_collect = res.is_collect;
			// 	this.action_id = action_id;
			// 	this.is_admin_publish = is_admin_publish;
			// 	this.source = source;
			// 	this.relNewsList = res.relation_news;
			// 	this.short_desc = short_desc;
			// }
		},

		async onFavClick() {
			const res = await apiUtil.post(apiConst.submitFav, {
				id: this.$route.query.id,
				type: 1
			});
			if (res.success) {
				this.is_collect = 1;
				Toast({
					message: '收藏成功',
					duration: 1000,
					background: '#8FC31E'
				});
			}
		},

		async onUnfavClick() {
			const res = await apiUtil.post(apiConst.submitUnfav, {
				id: this.$route.query.id,
				type: 1
			});
			if (res.success) {
				this.is_collect = 0;

				Toast({
					message: '已取消收藏',
					duration: 1000,
					background: '#8FC31E'
				});
			}
		},

		onUserClick() {
			this.$router.push({
				name: 'userCenter',
				query: {
					action_id: this.action_id,
					is_admin_publish: this.is_admin_publish
				}
			});
		},

		onShareClick() { }
	}
};
</script>
<style lang="stylus">
	#newsDetailView{
		height: 100%;
		overflow-y: auto;
	}
	#viewWrap{
		.tabs{
			margin-top: 30px;
			.van-tabs__wrap{
				.van-tabs__nav{
					.van-tabs__line{
						background-color: #5B9BD5;
					}
					.van-tab{
						.van-tab__text{
							font-size: 25px;
						}
					}
					.van-tab--active{
						font-weight: 600;
					}
				}
			}
		}
		
		.yearnumber .yearcontent{
			.eltables{
				margin-top: 20px;
			}
			.el-table{
				.el-table__header-wrapper .el-table__header thead tr th{
					background-color: #5b9bd5;
					color: #fff
				}
				.el-table__body-wrapper .el-table__body tbody .el-table__row td{
					padding: 20px 0;
					background-color: #d2deef;
					color: #000
				}
				.el-table__body-wrapper .el-table__body tbody .el-table__row--striped td{
					padding: 20px 0;
					background-color: #eaeff7;
					color: #000
				}
			}
		}
	}
	.yeartable{
		.eltables{
			margin-top: 20px;
		}
		.el-table{
			.el-table__header-wrapper .el-table__header thead tr th{
				background-color: #fff;
				color: #5b9bd5;
				border-bottom: solid 1px #bfbfbf;
			}
			.el-table__body-wrapper .el-table__body tbody .el-table__row td{
				padding: 20px 0;
				background-color: #fff;
			}
			.el-table__body-wrapper .el-table__body tbody .el-table__row--striped td{
				padding: 20px 0;
				background-color: #fff;
			}
		}
	}
</style>
<style lang="stylus" scoped>
.yeartable{
	margin: 0 40px;
	margin-bottom: 50px;
	.tablehead{
		height: 50px;
		line-height: 50px;
		color: #5B9BD5;
	}
	.tabldata{
		height: 40px;
		line-height: 40px;
	}
}
#viewWrap{
	margin: 0px auto;
	margin-top: 30px;
	width: 650px;
	::v-deep .van-tab__text{
		font-family: MicrosoftYaHei;
		font-stretch: normal;
		letter-spacing: 0px;
	}
	::v-deep .van-tabs__wrap{
		border-top: solid 1px #cccccc;
		border-bottom: solid 1px #cccccc;
		margin-top: 60px;
	}
	::v-deep .van-tabs__line{
		background-color: #8FC31E !important;
		width: 110px !important;
		border-radius: 0 !important;
	}
	.companyinfo{
		text-align: center;
		img{
			width: 80%;
			// height: 200px;
			margin-bottom: 20px;
		}
		.comname{
			font-weight: 600;
			font-size: 25px;	
			margin-top: 20px;
			font-family: MicrosoftYaHei;
			font-weight: normal;
			font-stretch: normal;
			letter-spacing: 0px;
			color: #999999;
		}
	}
	.tabcontent{
		text-indent:60px;
		margin: 30px 0;
		color:#333;
		font-size:30px;
		line-height: 50px;
		text-align: justify;
	}
	.companyurl{
		padding: 0 30px;
		height: 60px;
		background-color: #f2f2f2;
		color: #808080;
		display: flex;
		justify-content: space-evenly;
		align-items: center;
		// border-radius: 60px;
		margin: 30px 0;
		.urllayout{
			display: flex;
    	align-items: baseline;
			.urlnames{
				color: #333;
				font-size: 30px
			}
			.urlvalues{
				margin-left: 20px;
				display: inline-block;
				width: 300px;
				overflow:hidden;
				text-overflow:ellipsis; 
				white-space: nowrap;
				color: #46a4fc;
				height: 40px;
			}
		}
	}
	.chartline{
		width: 500px;
		margin: 0 auto;
		height: 60px;
		line-height: 60px;
		background-color: #d7f2fd;
		border-radius: 30px;
		margin-bottom 30px;
		text-align: center;
		// border-bottom: solid 1px #d9d9d9;
		.greenbottom{
			display: inline-block;
			height: 50px;
			line-height: 50px;
			// border-bottom: solid 5px #5B9BD5;
		}
	}
	.yearnumber{
		margin: 20px 0;
		.yeartitle{
			display: flex;
			align-items: center;
			.numbers{
				width: 25%;
				background-color: #d6dce5;
				text-align: center;
				height: 50px;
				line-height : 50px;
				border-radius: 50px;
			}
			.lines{
				height: 1px;
				background-color: #d9d9d9;
				width: 75%;
				margin-left: 5px;
			}
		}
		.yearcontent{
			margin: 30px 0;
			margin-bottom: 40px;
			.contentlay{
				height: 40px;
				line-height : 40px;
				font-size: 25px;
				.contentfont{
					color: #0070c0;
					margin-left: 20px;
					font-weight: 600;
				}
			}
			.layoutdev{
				margin-top: 30px;
			}
		}
		.seedetial{
			display: flex;
    		align-items: center;
			padding: 20px 0;
			background-image: linear-gradient(#e8f9c7, #fdfff7);
			.contentfont{
				font-size: 25px;
				color: #91ca2e;
				font-weight: 600;
			}
			.seeimg{
				width: 25px;
				margin-left: 15px;
			}
		}
	}
}
.devides{
	height: 30px;
	background-color: #f2f2f2;
}

</style>

<style scoped>

.news-detail-view .content-wrap >>> img {
	max-width: 100% !important;
	height: auto !important;
	display: block;
	margin: auto;
}
.news-detail-view .content-wrap >>> a {
	word-break: break-all;
}
</style>